/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { CoreStrictHttpResponse } from '../../core-strict-http-response';
import { CoreRequestBuilder } from '../../core-request-builder';

import { CoreProjectSubtaskCommentResponseDto } from '../../models/core-project-subtask-comment-response-dto';

export interface ProjectSubtaskCommentsControllerDelete$Params {

/**
 * The tenant identifier.
 */
  tenant: string;

/**
 * The comment ID.
 */
  id: string;
}

export function projectSubtaskCommentsControllerDelete(http: HttpClient, rootUrl: string, params: ProjectSubtaskCommentsControllerDelete$Params, context?: HttpContext): Observable<CoreStrictHttpResponse<CoreProjectSubtaskCommentResponseDto>> {
  const rb = new CoreRequestBuilder(rootUrl, projectSubtaskCommentsControllerDelete.PATH, 'delete');
  if (params) {
    rb.path('tenant', params.tenant, {});
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as CoreStrictHttpResponse<CoreProjectSubtaskCommentResponseDto>;
    })
  );
}

projectSubtaskCommentsControllerDelete.PATH = '/o2-core/project-subtask-comments/{tenant}/{id}';
